import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
import ServiceTwo from "../components/ServiceTwo";
import TransportServiceArea from "../components/TransportServiceArea";
import LogisticsTwo from "../components/LogisticsTwo";
import VideoAreaOne from "../components/VideoAreaOne";
const BannerOne = React.lazy(() => import("../components/BannerOne"));
const AboutOne = React.lazy(() => import("../components/AboutOne"));
const BlogOne = React.lazy(() => import("../components/BlogOne"));
const ContactOne = React.lazy(() => import("../components/ContactOne"));
const CounterOne = React.lazy(() => import("../components/CounterOne"));
const FeatureOne = React.lazy(() => import("../components/FeatureOne"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));
const PartnerOne = React.lazy(() => import("../components/PartnerOne"));
const PortfolioOne = React.lazy(() => import("../components/PortfolioOne"));
const ServiceOne = React.lazy(() => import("../components/ServiceOne"));
const TeamOne = React.lazy(() => import("../components/TeamOne"));
const TestimonialOne = React.lazy(() => import("../components/TestimonialOne"));
const WhyChooseUsOne = React.lazy(() => import("../components/WhyChooseUsOne"));
const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const HomeOne = () => {
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarOne />

          {/* Banner One */}
          <BannerOne />

          {/* Feature One */}
          <FeatureOne />

          {/* About One */}
          <AboutOne />

          {/* Service One */}
          {/* <ServiceOne /> */}
          {/* <ServiceTwo /> */}
          <TransportServiceArea />

          <LogisticsTwo />

          {/* Why Choose Us One */}
          <WhyChooseUsOne />

          {/* Counter One */}

          {/* <CounterOne /> */}

          {/* Team One */}
          {/* <TeamOne /> */}

          {/* Contact One */}
          <div
            className="call-to-contact-area "
            style={{ background: "#F9F9F9", paddingTop: 10 }}
          >
            {/* <ContactOne /> */}

            <VideoAreaOne />
          </div>

          {/* Testimonial One */}
          {/* <TestimonialOne /> */}

          {/* Portfolio One */}
          {/* <PortfolioOne /> */}

          {/* Blog One */}
          {/* <BlogOne /> */}

          {/* Partner One */}
          {/* <PartnerOne /> */}

          {/* Footer One */}
          <FooterOne />

          {/* Footer Bottom One */}
          <FooterBottomOne />
        </Suspense>
      </Fragment>
    </>
  );
};

export default HomeOne;
